import React from 'react';

import PropTypes from 'prop-types';

export default function PlusIcon({
  color = 'currentColor',
  size = 14,
  ...rest
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" {...rest}>
      <path
        d="M6.99985 1.61536V12.3846M1.61523 6.99997H12.3845"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

PlusIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
